export default __webpack_public_path__ + "svg/CompaniesLogos/Google_Cloud_logo.svg?3f729023";